import { FC, memo, useMemo } from 'react';
import StoriesComponent from 'react-insta-stories';
import type StoryType from 'react-insta-stories/dist/interfaces';
import StorySlide, { IStorySlideProps } from './components/StorySlide';
import { IStorySlide } from './Story.type';

interface IStoryProps
  extends Omit<StoryType.ReactInstaStoriesProps, 'stories'>,
    Omit<IStorySlideProps, 'url' | 'isPaused'> {
  slides: Array<IStorySlide>;
  isActive?: boolean;
}

const Story: FC<IStoryProps> = ({
  slides,
  progressStyles,
  progressWrapperStyles,
  progressContainerStyles,
  title,
  avatarUrl,
  isActive = true,
  id,
  onClose,
  ...rest
}) => {
  const stories = useMemo<StoryType.Story[]>(() => {
    if (!slides.length) return [];

    return slides.map((slide) => ({
      content: ({ isPaused }) => (
        <StorySlide
          avatarUrl={avatarUrl}
          isPaused={isPaused}
          title={title}
          onClose={onClose}
          {...slide}
        />
      ),
    }));
  }, [avatarUrl, onClose, slides, title]);

  if (!isActive) {
    return (
      <StorySlide
        avatarUrl={avatarUrl}
        id={slides[0].id}
        isPaused={false}
        title={title}
        url={slides[0].url || ''}
      />
    );
  }

  return (
    <div className="h-full w-full" id={id}>
      <StoriesComponent
        height="100%"
        progressContainerStyles={{
          padding: '24px 24px 24px 24px',
          filter: 'none',
          ...(progressContainerStyles ?? {}),
        }}
        progressStyles={{
          transformOrigin: 'right center',
          backgroundColor: '#0089BF',
          ...(progressStyles ?? {}),
        }}
        progressWrapperStyles={{
          height: '3px',
          borderRadius: '1px',
          backgroundColor: '#F0F2F5',
          ...(progressWrapperStyles ?? {}),
        }}
        stories={stories}
        width="100%"
        {...rest}
      />
    </div>
  );
};

export default memo(Story);
